import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base/base.component';
import { OrganisationContractVM } from '../../../models/OrganisationContractVM';
import { AccountService } from '../../../services/account.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'contracts',
  templateUrl: './contracts.component.html'
})
export class ContractsComponent extends BaseComponent implements OnInit {


  active: OrganisationContractVM[] = [];
  expired: OrganisationContractVM[] = [];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private accService: AccountService,
    private authService: AuthService
  ) {
    super(route);
  }

  ngOnInit(): void {

    this.accService.getContracts(true).subscribe(
      r => this.active = r,
      e => console.log(e)
    );

    this.accService.getContracts(false).subscribe(
      r => this.expired = r,
      e => console.log(e)
    );

  }

}
